import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { Lock, LockPolicy } from "../types/lock";

const c = initContract();

export const lockContract = c.router(
    {
        getLocks: {
            method: "GET",
            path: "/",
            query: z.object({
                entityIds: z.array(z.coerce.number()),
            }),
            responses: {
                200: c.type<{ locks: Lock[] }>(),
            },
        },
        getLock: {
            method: "GET",
            path: "/:entityId",
            responses: {
                200: c.type<{ locks: Lock[] }>(),
            },
        },
        updateLock: {
            method: "POST",
            path: "/:entityId",
            responses: {
                200: c.type<{ locks: Lock[] }>(),
            },
            body: z.object({
                date: z.string().nullable(),
                policy: z.nativeEnum(LockPolicy),
            }),
        },
    },
    {
        pathPrefix: "/lock",
    },
);
